import { useState, useEffect } from 'react';
import { projectFirestore } from '../firebase/config';

const useAIImages = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const unsub = projectFirestore.collection('ai-images')
            .orderBy('createdAt', 'desc')
            .onSnapshot((snap) => {
                const data = [];
                snap.forEach(doc => {
                    data.push({ ...doc.data(), id: doc.id });
                });
                setImages(data);
                setLoading(false);
                setError('');
            }, (err) => {
                console.error('AI images listener error:', err);
                setError(err?.message || 'تعذر الاتصال بقاعدة البيانات');
                setLoading(false);
            });

        return () => unsub();
    }, []);

    return { images, loading, error };
};

export default useAIImages;
